/// <reference path="../../_ext/Editors/BOMEditorDialog.ts" />
namespace TabAurous.Production {

    @Serenity.Decorators.registerClass()
    export class DismantlingBOMDialog extends _Ext.BOMEditorDialog<DismantlingBOMRow> { 
        protected getLocalTextPrefix() { return DismantlingBOMRow.localTextPrefix; }
        protected getDeletePermission() { return DismantlingBOMRow.deletePermission; }
        protected getInsertPermission() { return DismantlingBOMRow.insertPermission; }
        protected getUpdatePermission() { return DismantlingBOMRow.updatePermission; }
         
        protected get_ExtDialogOptions() {
            let opt = super.get_ExtDialogOptions();
            opt.AutoFitContentArea = false;
            opt.ShowSaveAndNewButtonInToolbar = false;
            opt.ShowDeleteButton = false;

            return opt;
        }
        constructor() {
            super();
            q.setTextRightAlign(this.form.Pieces);
            q.setTextRightAlign(this.form.Weight);
            q.setTextRightAlign(this.form.PointerWeight);
            q.setTextRightAlign(this.form.BomAmount);
            q.setTextRightAlign(this.form.BomRate);
            q.setTextRightAlign(this.form.Purity);
            q.setTextRightAlign(this.form.Purity);

            // Module Configuration
            this.UseKaratWiseRate = q.ToBool(TabAurous.GetConfigValue(1014));  

            this.form.BomRate.changeSelect2(e => {
                var calcon = this.form.CalcOnId.value;
                if (calcon == "4" || calcon == "5")
                    if (this.form.ItemTypeId.value == 104) {
                        if (this.UseKaratWiseRate == true)
                            this.form.BomAmount.value = this.form.BomRate.value * this.form.Weight.value || 0;
                        else
                            this.form.BomAmount.value = this.form.BomRate.value * this.form.Weight.value * this.form.Purity.value || 0;
                    }
                    else {
                        this.form.BomAmount.value = this.form.BomRate.value * this.form.Weight.value;
                    }
                if (calcon == "3")
                    this.form.BomAmount.value = this.form.BomRate.value * this.form.Pieces.value;

                //this.form.CCBomAmount.value = this.form.BomAmount.value * this.ExchangeRate;

            });

            this.form.Pieces.changeSelect2(e => {
                if (this.form.CalcOnId.value == "3") {
                    this.form.BomAmount.value = this.form.Pieces.value * this.form.BomRate.value;
                    //this.form.CCBomAmount.value = this.form.BomAmount.value * this.ExchangeRate;
                }
            });

            this.form.Weight.changeSelect2(e => {
                if (this.form.CalcOnId.value == "4" || this.form.CalcOnId.value == "5")
                    if (this.form.Purity.value > 0) {
                        this.form.BomAmount.value = this.form.Weight.value * this.form.BomRate.value * this.form.Purity.value;
                        this.form.PureWeight.value = this.form.Weight.value * this.form.Purity.value;
                    }
                    else {
                        this.form.BomAmount.value = this.form.Weight.value * this.form.BomRate.value
                    }
                //this.form.CCBomAmount.value = this.form.BomAmount.value * this.ExchangeRate;

            });

            // Validate Purity
            this.form.Purity.change(e => {
                var AttID = Q.toId(this.form.BOMAttributeId.value);
                if (AttID != null) {
                    var productID = this.form.BOMProductId.value;

                    let prddetails;
                    OMS.ProductMasterService.Retrieve({
                        EntityId: productID
                    }, response => {
                        prddetails = response.Entity
                    }, { async: false });
                    var max = prddetails.MaxPurity;
                    var min = prddetails.MinPurity;
                    var std = prddetails.StdPurity; var current = this.form.Purity.value;
                    if (current < min || current > max) {
                        Q.alert("Enter Purity between  " + min.toString() + "  to  " + max.toString());
                        this.form.Purity.value = std;
                    }
                }
                this.GetRate();

            });

        }

        GetRate() {
            var calcon = this.form.CalcOnId.value;
            this.RateListId = (this.parentEditor.parentDialog as DismantlingItemsDialog).RateListId;

            if (this.form.ItemTypeId.value == 104) {
                this.form.BomRate.value = RateHelper.GetMetalRate(parseInt(this.form.ProductTypeId.value), parseInt(this.form.KaratId.value), false, new Date());
                let UseKaratRate = q.ToBool(TabAurous.GetConfigValue(1021)); 

                this.form.BomRate.value = this.form.BomRate.value / this.ExchangeRate;
                if (calcon == "4" || calcon == "5")
                    this.form.BomAmount.value = UseKaratRate == true ? this.form.BomRate.value * this.form.Weight.value : this.form.BomRate.value * this.form.Weight.value * this.form.Purity.value

                if (calcon == "3")
                    this.form.BomAmount.value = this.form.BomRate.value * this.form.Pieces.value;
            }

            //this.form.CCBomAmount.value = this.form.BomAmount.value * this.ExchangeRate;
        }

        afterLoadEntity() {
            super.afterLoadEntity();
            this.setFields();
        }

        protected setFields() {

            switch (this.form.ItemTypeId.value) {

                case 105: {
                    q.hideField(this.form.KaratId);
                    q.hideField(this.form.Purity);
                    q.hideField(this.form.MetalColorId);
                    q.hideField(this.form.Purity);
                    q.hideField(this.form.PureWeight);
                    //q.hideField(this.form.GrossWeight);
                    q.showAndSetRequiredField(this.form.ShapeId);
                    q.showAndSetRequiredField(this.form.QualityId);
                    q.showAndSetRequiredField(this.form.StoneColorId);
                    q.showAndSetRequiredField(this.form.StoneSizeId);
                    q.showAndSetRequiredField(this.form.SieveId);
                    q.showAndDisableField(this.form.CategoryId);
                    q.showAndSetRequiredField(this.form.SubCategoryId);
                    q.showAndSetRequiredField(this.form.SettingId);
                    Serenity.EditorUtils.setRequired(this.form.Pieces, true);
                    Serenity.EditorUtils.setReadOnly(this.form.ShapeId, true);
                    var prdbomid = "";
                    if (this.form.BOMProductId.value != "")
                        prdbomid = this.form.BOMProductId.value;
                    this.form.BOMProductId.cascadeField = "ItemTypeId";
                    this.form.BOMProductId.cascadeValue = this.form.ItemTypeId.value;

                    this.form.BOMProductId.value = prdbomid;
                    switch (parseInt(this.form.CategoryId.value)) {
                        case 1:
                        case 3:
                        case 4:
                            q.hideField(this.form.StoneCutId);
                            q.hideField(this.form.StonePolishId);
                            q.hideField(this.form.StoneSymmetryId);
                            q.hideField(this.form.StoneFluorescenceId);
                            q.hideField(this.form.StoneCuletId);
                            q.hideField(this.form.StoneGirdleId);
                            q.hideField(this.form.StoneTable);
                            q.hideField(this.form.StoneDepth);
                            q.hideField(this.form.CertificateNo);
                            //q.hideEditorCategory(this.form.StoneCuletId);
                            break;
                        case 2:
                            q.showAndSetRequiredField(this.form.StoneCutId);
                            q.showAndSetRequiredField(this.form.StonePolishId);
                            q.showAndSetRequiredField(this.form.StoneSymmetryId);
                            q.showAndSetRequiredField(this.form.StoneFluorescenceId);
                            q.showAndSetRequiredField(this.form.StoneCuletId);
                            q.showAndSetRequiredField(this.form.StoneGirdleId);
                            q.showAndSetRequiredField(this.form.StoneTable);
                            q.showAndSetRequiredField(this.form.StoneDepth);
                            q.showAndSetRequiredField(this.form.CertificateNo);
                            q.showAndSetRequiredField(this.form.Pieces);
                            q.showAndSetRequiredField(this.form.Weight);
                            //q.showAndSetRequiredField(this.form.Lab);

                            break;
                        default:
                            q.hideField(this.form.StoneCutId);
                            q.hideField(this.form.StonePolishId);
                            q.hideField(this.form.StoneSymmetryId);
                            q.hideField(this.form.StoneFluorescenceId);
                            q.hideField(this.form.StoneCuletId);
                            q.hideField(this.form.StoneGirdleId);
                            q.hideField(this.form.StoneTable);
                            q.hideField(this.form.StoneDepth);
                            q.hideField(this.form.CertificateNo);
                            break;

                    }

                    break;
                }
                case 104: {
                    q.showAndSetRequiredField(this.form.KaratId);
                    q.showAndDisableField(this.form.MetalColorId);
                    q.showAndDisableField(this.form.KaratId);
                    q.showAndSetRequiredField(this.form.Purity);
                    q.showAndDisableField(this.form.PureWeight);
                    //q.showAndEnableField(this.form.GrossWeight);

                    q.hideField(this.form.ShapeId);
                    q.hideField(this.form.QualityId);
                    q.hideField(this.form.StoneColorId);
                    q.hideField(this.form.StoneSizeId);
                    q.hideField(this.form.SieveId);
                    q.hideField(this.form.Pieces);
                    q.hideField(this.form.CategoryId);
                    q.hideField(this.form.SubCategoryId);
                    q.hideField(this.form.CertificateNo);
                    q.hideField(this.form.SettingId);

                    var prdbomid = "";
                    if (this.form.BOMProductId.value != "")
                        prdbomid = this.form.BOMProductId.value;
                    this.form.BOMProductId.cascadeField = "ItemTypeId";
                    this.form.BOMProductId.cascadeValue = this.form.ItemTypeId.value;
                    this.form.BOMProductId.value = prdbomid;
                    break;
                }

                default: {
                    q.hideField(this.form.KaratId);
                    q.hideField(this.form.Purity);
                    q.hideField(this.form.MetalColorId);
                    q.hideField(this.form.ShapeId);
                    q.hideField(this.form.QualityId);
                    q.hideField(this.form.StoneColorId);
                    q.hideField(this.form.StoneSizeId);
                    q.hideField(this.form.SieveId);
                    Serenity.EditorUtils.setRequired(this.form.Pieces, false);
                    this.form.BOMProductId.value = "";
                    this.form.BOMProductId.cascadeField = "ItemTypeId";
                    this.form.BOMProductId.cascadeValue = this.form.ItemTypeId.value;
                    break;
                }
            }
        }

        protected validateBeforeSave() {
            this.entity.RefTransBomId === undefined ? this.entity.RefTransBomId = 0 : this.entity.RefTransBomId;
            return true;
        }
    }
}